import React, { useState } from "react";
import { Input } from "@windmill/react-ui";
import { IoIosMail } from "react-icons/io";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

const InputArea = ({
  register,
  trigger,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  onChange,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const validation = {
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength} !`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength} !`,
    },
    validate: (value) => {
      if (
        typeof value === "string" &&
        value.trim() === "" &&
        required !== false
      ) {
        return `${label} is required!`;
      }
      if (type === "number") {
        const numericValue = Number(value);
        if (isNaN(numericValue) || numericValue <= 0) {
          return `${label} must be greater than 0!`;
        }
      }
      return true;
    },
  };

  const handleInput = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length > maxLength) {
      event.target.value = inputValue.slice(0, maxLength);
      return;
    }
  };

  return (
    <div className="relative w-full">
      {/* Icon for Email */}

      <Input
        {...register(`${name}`, validation)}
        defaultValue={defaultValue}
        type={name === "password" ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        onInput={handleInput}
        name={name}
        value={value}
        autoComplete="off"
        readOnly={readOnly}
        className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
      />

      {name === "email" && <IoIosMail className="loginInput" />}

      {/* Toggle Icon for Password */}
      {name === "password" && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="loginInput"
        >
          {showPassword ? <FaEye /> : <FaEyeSlash />}
        </button>
      )}
    </div>
  );
};

export default InputArea;
